import { Divider, SxProps, Theme } from '@mui/material'
import { grey } from '@mui/material/colors'

export const InputSectionDivider = ({ label, sx }: { label: string; sx?: SxProps<Theme> }) => (
  <Divider
    flexItem
    textAlign="left"
    sx={{
      py: 0.25,
      '& .MuiDivider-wrapper': {
        pl: 0.15,
        color: ({ palette }) => (palette.mode === 'light' ? grey[700] : grey[400]),
        fontSize: 12
      },
      '&::before': { width: 0 },
      ...sx
    }}
  >
    {label}
  </Divider>
)
